const CPIChangeLabelIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1673 5H5.83398C4.5079 5 3.23613 5.52678 2.29845 6.46447C1.36077 7.40215 0.833984 8.67392 0.833984 10C0.833984 11.3261 1.36077 12.5979 2.29845 13.5355C3.23613 14.4732 4.5079 15 5.83398 15H14.1673C15.4934 15 16.7652 14.4732 17.7029 13.5355C18.6405 12.5979 19.1673 11.3261 19.1673 10C19.1673 8.67392 18.6405 7.40215 17.7029 6.46447C16.7652 5.52678 15.4934 5 14.1673 5Z"
        stroke="#A88CA4"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M14.166 12.5C14.8291 12.5 15.4649 12.2366 15.9338 11.7678C16.4026 11.2989 16.666 10.663 16.666 10C16.666 9.33696 16.4026 8.70107 15.9338 8.23223C15.4649 7.76339 14.8291 7.5 14.166 7.5C13.503 7.5 12.8671 7.76339 12.3982 8.23223C11.9294 8.70107 11.666 9.33696 11.666 10C11.666 10.663 11.9294 11.2989 12.3982 11.7678C12.8671 12.2366 13.503 12.5 14.166 12.5Z"
        fill="#A88CA4"
        stroke="#A88CA4"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CPIChangeLabelIcon
